import React from 'react';
import PropTypes from 'prop-types';
import { Image, ButtonWithIcon } from 'modules/styled';

const MetamaskIcon = require('public/img/metamask.png');

const MetamaskIconComponent = (
  <Image
    resizeMode={'contain'}
    source={MetamaskIcon}
    sx={{ width: 4, height: 4, mr: 1.5 * 8.001 }}
  />
);

const DesktopIcon = require('public/img/desktop.png');

const DesktopIconComponent = (
  <Image
    resizeMode={'contain'}
    source={DesktopIcon}
    sx={{ width: 4, height: 4, mr: 1.5 * 8.001 }}
  />
);

MetamaskButton.propTypes = {
  onPress: PropTypes.func,
  text: PropTypes.string,
  sx: PropTypes.object,
};

export function MetamaskButton({ text, onPress, sx }) {
  return (
    <ButtonWithIcon
      sx={{ bg: '#161616', ...sx }}
      image={MetamaskIconComponent}
      text={text}
      onPress={onPress}
    />
  );
}

ConnectDesktopButton.propTypes = {
  onPress: PropTypes.func,
  text: PropTypes.string,
  sx: PropTypes.object,
};

export function ConnectDesktopButton({ text, onPress, sx }) {
  return (
    <ButtonWithIcon onPress={onPress} sx={sx} image={DesktopIconComponent} text={text} />
  );
}
